import simg1 from "../images/service/gift-box.svg";
import simg2 from "../images/service/planting.svg";
import simg3 from "../images/service/healthcare.svg";
import simg4 from "../images/service/graduate-cap.svg";

import sSimg1 from "../images/service-single/1.jpg";
import sSimg2 from "../images/service-single/2.jpg";
import sSimg3 from "../images/service-single/3.jpg";
import sSimg4 from "../images/service-single/4.jpg";

const Services = [
  {
    Id: "01",
    sImg: simg1,
    sSImg: sSimg1,
    title: "Thiết kế vải với AI",
    slug: "01",
    description:
      "Giải phóng sức sáng tạo và tạo ra những mẫu vải độc đáo, ấn tượng bằng công nghệ AI tiên tiến. Khám phá tiềm năng vô tận của thiết kế vải chưa bao giờ dễ dàng đến thế!",
  },
  {
    Id: "02",
    sImg: simg2,
    sSImg: sSimg2,
    title: "Hình ảnh nổi bật",
    slug: "02",
    description:
      "Khám phá bộ sưu tập hình ảnh độc đáo về vẻ đẹp tinh xảo của vải và nghề dệt thủ công truyền thống Việt Nam. Chiêm ngưỡng những khoảnh khắc ấn tượng ghi lại quy trình dệt vải.",
  },
  {
    Id: "03",
    sImg: simg3,
    sSImg: sSimg3,
    title: "Học toán qua hoạ tiết vải",
    slug: "03",
    description:
      "Kết hợp toán học và nghệ thuật một cách sáng tạo! Biến những hoạ tiết vải quen thuộc thành công cụ học tập thú vị, giúp trẻ em khám phá thế giới toán học trực quan.",
  },
  {
    Id: "04",
    sImg: simg4,
    sSImg: sSimg4,
    title: "Tích hợp AI Chatbot",
    slug: "04",
    description:
      "Khám phá sự tiện lợi của AI Chatbot tích hợp. Nhận tư vấn cá nhân hóa, giải đáp mọi thắc mắc về văn hoá truyền thống, nâng cao trải nghiệm.",
  },
];

export default Services;
